import GetOne from "./organization/getOne";
import requestApi from "helpers/fetcher";

export const getOneOrganization = organizationId =>
	requestApi(new GetOne(organizationId));
